import {useState} from 'react'
import {getCompany} from '../services'
import {CompanyModel, SelectModel} from '../model'
import {mapDataSelect} from '../../../util/functions'
const useCompany = () => {
  const [loading, setLoading] = useState(false)
  const [companyList, setCompanyList] = useState<SelectModel[]>([])

  const getCompanyService = async (companyParams: CompanyModel) => {
    let obj: CompanyModel = {
      isCombo: true,
      ...companyParams,
    }
    return await getCompany(obj, 1)
  }
  const getCompanyData = async (companyParams: CompanyModel) => {
    setLoading(true)
    try {
      const response = await getCompanyService(companyParams)
      return response.data.data
    } catch (error) {
      console.error('Error fetching company data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }
  const getCompanyFD = async (companyParams: CompanyModel) => {
    setLoading(true)
    try {
      const data = await getCompanyData(companyParams)
      const mapped = mapDataSelect(data, 'id', 'nombreEmpresa')
      return mapped
    } catch (error) {
      console.error('Error fetching company data:', error)
      return []
    } finally {
      setLoading(false)
    }
  }

  const updateCompanyList = (mapped: {value: string; label: string}[]) => {
    setCompanyList(mapped)
  }

  const getCompanyList = async (companyParams: CompanyModel = {}) => {
    try {
      const data = await getCompanyData(companyParams)
      const mapped = mapDataSelect(data, 'id', 'nombreEmpresa')
      updateCompanyList(mapped)
    } catch (error) {
      console.error('Error fetching company data:', error)
    }
  }

  const handleClear = () => {
    setCompanyList([])
  }

  return {
    loading,
    companyList,
    getCompanyList,
    getCompanyService,
    getCompanyFD,
    handleClear,
  }
}
export default useCompany
